<template>
  <div class="ref-nav-container">
    <div class="ref-brand-section">
      <a @click="changeFederation(0, 'RDRS')" class="ref-brand-link" href="/">
        <img src="/images/RDRS-logo.png" alt="Logo" class="ref-brand-logo">
        <div class="ref-brand-titles">
          <span class="ref-brand-main">{{ storeFederationName || 'RDRS Union Federation' }}</span>
        </div>
      </a>
      
      <button 
        class="ref-mobile-toggle" 
        @click="toggleMobileMenu" 
        :aria-expanded="isMobileMenuOpen"
        aria-label="Toggle navigation"
      >
        <span class="hamburger-bar" :class="{ open: isMobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
    </div>

    <div class="ref-divider-v d-none d-lg-block"></div>

    <ul class="ref-menu-list" :class="{ 'mobile-show': isMobileMenuOpen }">
      <li :class="{ active: isActive('/') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" @click="changeFederation(0, 'RDRS')" href="/">
          <i class="fa fa-home nav-icon"></i>
          <span class="nav-text">Home</span>
        </a>
        <a v-else @click="changeFederation(0, 'RDRS')" href="/">
          <i class="fa fa-desktop nav-icon"></i>
          <span class="nav-text">Back To Website</span>
        </a>
      </li>
      
      <li v-if="storeFederationId !== 0" :class="{ active: isActive('/federationdetails') }" @click="closeMobileMenu">
        <a :href="'/federationdetails/' + storeFederationId">
          <i class="fa fa-users nav-icon"></i>
          <span class="nav-text">Federation Details</span>
        </a>
      </li>

      <li v-if="storeFederationId == 0" :class="{ active: isActive('/overviews') }" @click="closeMobileMenu">
        <a href="/overviews">
          <i class="fa fa-desktop nav-icon"></i>
          <span class="nav-text">Overview</span>
        </a>
      </li>
      
      <li v-if="storeFederationId == 0" :class="{ active: isActive('/federation') }" @click="closeMobileMenu">
        <a href="/federation">
          <i class="fa fa-sitemap nav-icon"></i>
          <span class="nav-text">Federation</span>
        </a>
      </li>

      <li v-if="storeFederationId == 0" :class="{ active: isActive('/federationmember-list') }" @click="closeMobileMenu">
        <a href="/federationmember-list">
          <i class="fa fa-id-card-o nav-icon"></i>
          <span class="nav-text">Federation Member List</span>
        </a>
      </li>

      <li :class="{ active: isActive('/report') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" href="/report">
          <i class="fa fa-file-text-o nav-icon"></i>
          <span class="nav-text">Report</span>
        </a>
        <a v-else :href="'/report/' + storeFederationId">
          <i class="fa fa-file-text-o nav-icon"></i>
          <span class="nav-text">Report</span>
        </a>
      </li>
      
      <li v-if="storeFederationId !== 0" :class="{ active: isActive('/member-wings') }" @click="closeMobileMenu">
        <a :href="'/member-wings/' + storeFederationId">
          <i class="fa fa-users nav-icon"></i>
          <span class="nav-text">Member & Wings</span>
        </a>
      </li>

      <li v-if="storeFederationId !== 0" :class="{ active: isActive('/certificates') }" @click="closeMobileMenu">
        <a :href="'/certificates/' + storeFederationId">
          <i class="fa fa-certificate nav-icon"></i>
          <span class="nav-text">Certificate</span>
        </a>
      </li>
      
      <li v-if="storeFederationId == 0" :class="{ active: isActive('/career') }" @click="closeMobileMenu">
        <a href="/career">
          <i class="fa fa-briefcase nav-icon"></i>
          <span class="nav-text">Career</span>
        </a>
      </li>
      
      <li :class="{ active: isActive('/view-notice') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" href="/view-notice">
          <i class="fa fa-bullhorn nav-icon"></i>
          <span class="nav-text">Notice</span>
        </a>
        <a v-else :href="'/view-notice/' + storeFederationId">
          <i class="fa fa-bullhorn nav-icon"></i>
          <span class="nav-text">Notice</span>
        </a>
      </li>
      
      <li :class="{ active: isActive('/view-volunteer') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" href="/view-volunteer">
          <i class="fa fa-heart-o nav-icon"></i>
          <span class="nav-text">Volunteers</span>
        </a>
        <a v-else :href="'/view-volunteer/' + storeFederationId">
          <i class="fa fa-heart-o nav-icon"></i>
          <span class="nav-text">Volunteers</span>
        </a>
      </li>
      
      <li :class="{ active: isActive('/gallery') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" href="/gallery">
          <i class="fa fa-picture-o nav-icon"></i>
          <span class="nav-text">Gallery</span>
        </a>
        <a v-else :href="'/gallery/' + storeFederationId">
          <i class="fa fa-picture-o nav-icon"></i>
          <span class="nav-text">Gallery</span>
        </a>
      </li>
      
      <li :class="{ active: isActive('/allblog') || isActive('/blog-detail') }" @click="closeMobileMenu">
        <a v-if="storeFederationId == 0" href="/allblog">
          <i class="fa fa-newspaper-o nav-icon"></i>
          <span class="nav-text">Blog</span>
        </a>
        <a v-else :href="'/allblog/' + storeFederationId">
          <i class="fa fa-newspaper-o nav-icon"></i>
          <span class="nav-text">Blog</span>
        </a>
      </li>
      
      <li v-if="storeFederationId == 0" :class="{ active: isActive('/contact') }" @click="closeMobileMenu">
        <a href="/contact">
          <i class="fa fa-envelope-o nav-icon"></i>
          <span class="nav-text">Contact</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPath: window.location.pathname,
      isMobileMenuOpen: false
    };
  },
  computed: {
    storeFederationId() {
      return this.$store.state.federationId;
    },
    storeFederationName() {
      return this.$store.state.federationName;
    },
    url() {
      return this.$store.state.url;
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') {
        return this.currentPath === '/';
      }
      if (path === '/federation') {
        return this.currentPath === '/federation';
      }
      return this.currentPath.startsWith(path);
    },
    changeFederation(value, text) {
      this.$store.dispatch('updateEventValue', { value, text });
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.ref-nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 0;
  position: relative;
}

.ref-brand-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ref-brand-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
}

.ref-brand-logo {
  height: 52px;
  width: auto;
  border-radius: 50%;
  border: 2px solid #ed1c24;
  padding: 2px;
}

.ref-brand-titles {
  display: flex;
  flex-direction: column;
}

.ref-brand-main {
  color: #102640;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.2;
  max-width: 220px;
}

.ref-divider-v {
  width: 1.5px;
  height: 38px;
  background-color: #e2e8f0;
  margin: 0 15px;
}

.ref-mobile-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
}

.hamburger-bar {
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger-bar span {
  height: 2.5px;
  width: 100%;
  background-color: #102640;
  border-radius: 2px;
  transition: all 0.3s;
}

.hamburger-bar.open span:nth-child(1) {
  transform: translateY(7.5px) rotate(45deg);
  background-color: #ed1c24;
}
.hamburger-bar.open span:nth-child(2) {
  opacity: 0;
}
.hamburger-bar.open span:nth-child(3) {
  transform: translateY(-7.5px) rotate(-45deg);
  background-color: #ed1c24;
}

.ref-menu-list {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0;
  flex: 1;
  justify-content: space-between;
}

.ref-menu-list > li {
  position: relative;
  display: flex;
  align-items: center;
}

.ref-menu-list > li::after {
  content: "";
  position: absolute;
  right: 0;
  top: 25%;
  height: 50%;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.08);
}

.ref-menu-list > li:last-child::after {
  display: none;
}

.ref-menu-list > li > a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 9px;
  color: #1a2b4c;
  text-decoration: none !important;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.nav-icon {
  font-size: 16px;
  color: #1a2b4c;
  margin-bottom: 3px;
  transition: color 0.2s ease;
}

.nav-text {
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: 0.1px;
}

.ref-menu-list > li > a:hover {
  color: #ed1c24;
}

.ref-menu-list > li > a:hover .nav-icon {
  color: #ed1c24;
  transform: translateY(-2px);
}

/* Active Tab Ribbon Style matching reference image */
.ref-menu-list > li.active > a {
  background: #ed1c24;
  color: #ffffff !important;
  clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  padding: 8px 14px;
  box-shadow: 0 4px 10px rgba(237, 28, 36, 0.3);
  margin: 0 2px;
}

.ref-menu-list > li.active > a .nav-icon {
  color: #ffffff !important;
}

.ref-menu-list > li.active::after {
  display: none;
}

@media (max-width: 991px) {
  .ref-nav-container {
    flex-direction: column;
    align-items: stretch;
  }
  .ref-brand-section {
    width: 100%;
  }
  .ref-mobile-toggle {
    display: block;
  }
  .ref-menu-list {
    display: none;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
    background: #ffffff;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 8px 0;
  }
  .ref-menu-list.mobile-show {
    display: flex;
  }
  .ref-menu-list > li {
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
  }
  .ref-menu-list > li::after {
    display: none;
  }
  .ref-menu-list > li > a {
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    padding: 12px 18px;
    border-radius: 0;
  }
  .nav-icon {
    font-size: 18px !important;
    margin-bottom: 0;
  }
  .nav-text {
    font-size: 14.5px !important;
    font-weight: 700 !important;
  }
  .ref-menu-list > li.active > a {
    clip-path: none;
    margin: 0;
    border-radius: 0;
    background: #ed1c24 !important;
    color: #ffffff !important;
  }
}
</style>


